import { Text } from '@/shared/ui/primitives';
import type { ComponentProps, FC } from 'react';

import styles from './SectionLabel.module.css';

type SectionLabelProps = Omit<ComponentProps<typeof Text>, 'variant' | 'weight'>;

export const SectionLabel: FC<SectionLabelProps> = ({ className, children, ...rest }) => (
  <Text
    variant="subheadline"
    weight="regular"
    className={[styles.label, className].filter(Boolean).join(' ')}
    {...rest}
  >
    {children}
  </Text>
);
